// Static AU lending industry thresholds. These are de-facto constants
// (80% = LMI line, 90% = top of most lender appetite) and unlikely to
// change. Everything else previously in this file has moved to the
// live `CalculationSettings` payload.

/** LVR above this lifts the status from green → amber (LMI line). */
export const LVR_AMBER_THRESHOLD = 80;

/** LVR above this lifts the status from amber → red. */
export const LVR_RED_THRESHOLD = 90;
